import styles from './styles'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'

const GatedContentThankYou = () => {
  const { addTrackingForCTA } = useAnalytics()
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.heading}>Want to hire developers? 🔎</h3>
      <p className={styles.content}>Want to try OfferZen? Sign up to browse active developers. No upfront payment required.</p>
      <div className={styles.ctas}>
        <a
          {...addTrackingForCTA({
            action: 'clicked get access',
            sourceDetail: 'gated content thank you banner',
            url: '/company/signup?marketplace_preview_lead=true',
          })}
          className={`${styles.cta} ${styles.ctaFilled}`}>
          Get access to developers
        </a>
        <a
          {...addTrackingForCTA({
            action: 'clicked book a demo',
            sourceDetail: 'gated content thank you banner',
            url: '/hire/book-call?marketplace_preview_lead=true',
          })}
          className={styles.cta}>
          Book a demo
        </a>
      </div>
    </div>
  )
}

export default GatedContentThankYou
